// Esta funcion se encarga de presentar el formulario como (cliente NO) de manera predeterminada,
// ,de eliminar la pregunta y una de las lineas del formulario.
export function desactivarPreguntaCliente(answer = "no") {
    const observerPregunta = new MutationObserver(() => {
        const btnEsCliente = document.getElementById(answer);
        const containerPregunta = document.getElementsByClassName("seguro_container")[0];
        const containerLines = document.getElementsByClassName("hr_style")[1];

        if (btnEsCliente && containerPregunta && containerLines) {
            btnEsCliente.click();
            containerPregunta.style.display = "none";
            containerLines.style.display = "none";

            const observerPreguntaFinish = setTimeout(() => {
                observerPregunta.disconnect();
                clearTimeout(observerPreguntaFinish);
            }, 3000);
        }
    });
    observerPregunta.observe(document.body, { childList: true, subtree: true });
}